import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const dMDomainsApi = createApi({
  reducerPath: 'dMDomainsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Domains'],
  endpoints: (builder) => ({
    getDomains: builder.query({
      query: (params) => ({
        url: `/domains/`,
        params,
      }),
      providesTags: ['Domains'],
    }),

    createDomain: builder.mutation({
      query: (body) => ({
        url: '/domains/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Domains'],
    }),

    getDomainById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/domains/${id}/`,
        params,
      }),
      providesTags: (result, error, { id }) => [{ type: 'Domains', id }],
    }),

    updateDomainById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Domains'],
    }),
    updateDomainBulk: builder.mutation({
      query: ({ body }) => ({
        url: `/domains/bulk-update/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Domains'],
    }),

    deleteDomainById: builder.mutation({
      query: (id) => ({
        url: `/domains/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Domains'],
    }),

     calculateIpAddress: builder.query({
      query: ({ip}) => ({
        url: `/domains/calculate-ip-address-from-domain-name/?domain=${ip}`,
      }),
    }),
  }),
});

export const {
  useGetDomainsQuery,
  useLazyGetDomainsQuery,
  useCreateDomainMutation,
  useGetDomainByIdQuery,
  useUpdateDomainByIdMutation,
  useUpdateDomainBulkMutation,
  useDeleteDomainByIdMutation,
  useCalculateIpAddressQuery
} = dMDomainsApi;
